<template>
    <div class="select-none flex flex-col gap-4 justify-between h-full 6 w-full bg-green-100 border border-green-200 text-green-600 text-sm p-6 rounded-2xl shadow-md"
         style="min-height: 244px">
        <template v-if="!loading && stats">
            <div class="flex flex-wrap gap-2 justify-center w-full font-medium text-xl">
                <span>Open Tickets</span>

                <button @click="openTicketCreateModal()">
                    <icon-plus-circle class="hover:text-green-400 cursor-pointer ml-2 h-6 w-6 transition duration-300"></icon-plus-circle>
                </button>
            </div>

            <div class="flex items-center justify-center gap-x-6">
                <a :href="stats.open.link" target="_blank"
                   class="hover:text-green-400 transition duration-300 font-bold text-4xl flex flex-col items-center leading-none">
                    <span>{{ stats.open.stat }}</span>
                    <span class="font-medium text-sm">Yours</span>
                </a>

                <icon-hammer-and-wrench class="w-10 h-10"></icon-hammer-and-wrench>

                <a :href="stats.team_open.link" target="_blank"
                   class="hover:text-green-400 transition duration-300 font-bold text-4xl flex flex-col items-center leading-none">
                    <span>{{ stats.team_open.stat }}</span>
                    <span class="font-medium text-sm">Team</span>
                </a>
            </div>

            <div class="flex justify-center items-center w-full space-x-2">
                <a :href="stats.unresolved.link" target="_blank" class="inline font-black text-lg hover:text-green-400 transition duration-300">
                    {{ stats.unresolved.stat }}
                </a>

                <span class="font-normal">unresolved</span>

                <a :href="stats.team_unresolved.link" target="_blank"
                   class="text-lg font-normal text-md hover:text-green-400 transition duration-300">
                    {{ stats.team_unresolved.stat }}
                </a>
            </div>
        </template>

        <template v-else>
            <div class="flex justify-center items-center font-medium text-lg">
                <icon-refresh class="h-6 w-6 animate-spin"/> &nbsp;Loading...
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "TicketStatsCard",

    data () {
        return {
            loading: true,
            stats: null,
        };
    },

    mounted () {
        this.fetchStats();
    },

    methods: {
        fetchStats () {
            this.loading = true;
            axios.get("/home/tickets/stats")
            .then(response => {
                this.stats = response.data;
                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
                toastr.error(error.data.message);
            });
        },

        openTicketCreateModal () {
            this.$emit("open-ticket-create-modal");
        },
    },
};
</script>
